module.exports = __webpack_public_path__ + "img/94.f155036e.png";